import { render, staticRenderFns } from "./PaymentNewCateGory.vue?vue&type=template&id=f46be718&scoped=true"
import script from "./PaymentNewCateGory.vue?vue&type=script&lang=ts"
export * from "./PaymentNewCateGory.vue?vue&type=script&lang=ts"
import style0 from "./PaymentNewCateGory.vue?vue&type=style&index=0&id=f46be718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46be718",
  null
  
)

export default component.exports